<script lang="ts">
  import { Language } from "../models/state";
  import { RepositorySidebarProps } from "../models/props";



	

	let { description, website, stars, languages }: RepositorySidebarProps = $props();
</script>

<aside class="space-y-6">
	<section>
		<h3 class="font-semibold mb-3 text-gray-900 dark:text-gray-200">About</h3>
		<p class="text-sm text-gray-600 dark:text-gray-400 mb-4">{description}</p>

		{#if website}
			<a
				href={website}
				target="_blank"
				rel="noopener noreferrer"
				class="text-sm text-blue-600 dark:text-blue-400 hover:underline flex items-center mb-3"
			>
				<svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
					/>
				</svg>
				{website}
			</a>
		{/if}

		<p class="text-sm text-gray-600 dark:text-gray-400 flex items-center">
			<svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
				<path
					d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
				/>
			</svg>
			<span class="font-semibold">{stars}</span>
			<span class="ml-1">stars</span>
		</p>
	</section>

	{#if languages.length > 0}
		<section class="pt-6 border-t border-gray-200 dark:border-gray-700">
			<h3 class="font-semibold mb-3 text-gray-900 dark:text-gray-200">Languages</h3>

			<!-- Language bar -->
			<div class="w-full h-2 rounded-full mb-3 flex overflow-hidden">
				{#each languages as lang}
					<div style="width: {lang.percentage}%; background-color: {lang.color}"></div>
				{/each}
			</div>

			<!-- Language list -->
			<div class="text-xs space-y-2">
				{#each languages as lang}
					<p class="flex justify-between items-center text-gray-600 dark:text-gray-400">
						<span class="flex items-center">
							<span
								class="w-3 h-3 rounded-full mr-2"
								style="background-color: {lang.color}"
							></span>
							{lang.name}
						</span>
						<span>{lang.percentage.toFixed(1)}%</span>
					</p>
				{/each}
			</div>
		</section>
	{/if}
</aside>
